import { Checkbox, Grid } from '@mui/material';
import { FormikProps } from 'formik';
import {
  ArchiveAnnotationsForm,
  ArchiveAnnotationsListVM,
} from 'civil-status/view-models/archive-annotations-list';
import { Fragment, memo, useEffect } from 'react';
import Table from 'shell/components/shared/table';
import { noop } from 'shell/utils/noop';
import { headCells } from 'civil-status/constants/head-cells-archive-annotations';
import { useEventCallback } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';

interface TableArchiveAnnotationsProps {
  formContext: FormikProps<ArchiveAnnotationsForm>;
  body: Array<ArchiveAnnotationsListVM>;
  lengthList: number;
  onClickRegistration: () => void;
  onClickPrint: () => void;
  onClickReject: () => void;
}

const TableArchiveAnnotationsComponent = ({
  formContext,
  body,
  lengthList,
  onClickRegistration,
  onClickPrint,
  onClickReject,
}: TableArchiveAnnotationsProps): React.ReactElement => {
  useEffect(() => {
    if (
      formContext.values.itemsSelected?.length === lengthList &&
      !formContext.values.isSelectedAll
    ) {
      formContext.setFieldValue('isSelectedAll', true);
    }
  }, [formContext.values.itemsSelected, formContext.values.isSelectedAll]);

  const handleChangePage = useEventCallback((newPage) => {
    formContext.setFieldValue('page', newPage);
  });

  const handleChangeRowsPerPage = useEventCallback((rowsPerPage) => {
    const newDataset = {
      ...formContext.values,
      rowsPerPage: rowsPerPage || 0,
      page: 0,
    };
    formContext.setValues(newDataset as ArchiveAnnotationsForm);
  });

  const onChangeCheckboxAll = useEventCallback((oldIsSelectedAll: boolean) => {
    formContext.setValues({
      ...(formContext.values || {}),
      isSelectedAll: !oldIsSelectedAll,
      itemsSelected: oldIsSelectedAll ? [] : body.map((item) => item.id),
    });
  });

  return (
    <Fragment>
      <Grid item xs={12} display="flex" justifyContent="end" alignItems="center">
        <span style={{ fontWeight: formContext.values?.isSelectedAll ? 'bold' : 'normal' }}>
          SELEZIONA TUTTI
        </span>
        &nbsp;
        <FormControlLabel
          control={
            <Checkbox
              checked={formContext.values?.isSelectedAll || false}
              onChange={() => onChangeCheckboxAll(formContext.values?.isSelectedAll || false)}
              inputProps={{ 'aria-label': 'Seleziona tutti' }}
            />
          }
          label=""
        />
      </Grid>
      <Table
        body={body}
        onSort={noop}
        noSort
        head={headCells}
        orders={formContext.values.orders || {}}
        page={formContext.values.page || 0}
        rowsPerPage={formContext.values.rowsPerPage}
        onVisibilityPress={noop}
        onEditPress={noop}
        onTrashPress={noop}
        count={lengthList}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ariaLabel="Annotazioni su atto"
        hideButtons
      />
      <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={onClickPrint}
          style={{ marginRight: '2rem' }}
        >
          Stampa
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={onClickRegistration}
          style={{ marginRight: '2rem' }}
        >
          Registra
        </PmiButton>
        <PmiButton color="cdmBrandThird" variant="outlined" onClick={onClickReject}>
          Rifiuta
        </PmiButton>
      </Grid>
    </Fragment>
  );
};

TableArchiveAnnotationsComponent.displayName = 'Table Archive Annotations component';

const TableArchiveAnnotations = memo(TableArchiveAnnotationsComponent);
export default TableArchiveAnnotations;
